import Page from 'components/Page';
import React from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import CardBlock from 'reactstrap/es/CardBlock';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS,} from '../utils/Global';
import {allIsEmpty, cloneObject, isEmpty, parseDate, sortirMap} from '../utils/Utilities';
import {MdDelete, MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import ActiveOption from '../components/Widget/ActiveOption';
import ActiveLabel from '../components/Widget/ActiveLabel';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'

import NumberInput from '../components/Widget/NumberInput';
import ItemOption from '../components/Widget/ItemOption';
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../components/form/DropdownInput";

const tableTypes = ['', 'bordered', 'striped', 'hover'];


class MainModelPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      models:[],
      model:{},
      mainModels : [],
      mainModel:{},
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      modal: false,
      ascending:true,
      sortir:'created',
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.fetchAll()
    this.fetchPublishedModel()
  }

  confirmSave = () =>{
    var mainModel = this.state.mainModel
    var model = this.state.model
    if((isEmpty(model) || isEmpty(model.id)) && allIsEmpty(mainModel.label, mainModel.sortir)){
      this.showDialog(label.Warning, label.PleaseCompleteTheFields)
    }else{
      this.setState({
        modalAddConfirm:true
      })
    }
  }


  saveUpload = () => {
    let mainModel = this.state.mainModel

    if(!mainModel.id && !mainModel.active){
      mainModel.active = false ;
    }
    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Global.API.MAIN_MODEL_SAVE_UPLOAD, mainModel, null, res=>{
        if(res.code===200){
          this.setState({
            mainModel:{}
          }, () => {
            this.showDialog(label.Success, res.message)
            this.fetchAll()
            // this.fetch(this.state.mainModel.id)
            // changeParam(this.props, 'id', this.state.product.id)
          })
        }
      },  true, true)
    })
  }


  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Global.API.MAIN_MODEL_DELETE+"/"+this.state.mainModel.id, null, null, res => {
        if(res.code===200){
          this.setState({
            mainModel:{},
            model:{}
          }, () => {
            this.fetchAll()
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  fetchAll = () => {
    this.get(Global.API.MAIN_MODELS, {
      params:{
        ascending:this.state.ascending,
        sortir:this.state.sortir,
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          mainModels : response.data
        })
      }
    }, true, true);
  }

  fetchPublishedModel = () => {
    this.get(Global.API.MODELS_PUBLISHED, {
      params:{
        ascending:true,
        sortir:"jt.systemType"
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          models : response.data,
        })
      }
    }, true, true);
  }


  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll()
      })
  )


  render() {
    let aspect = 4/4
    let mainModel = this.state.mainModel?this.state.mainModel:{}
    let models = this.state.models?this.state.models:[]
    let model = this.state.model?this.state.model:{}

    let {ascending, sortir} = this.state
    let orderOptions = delegateObjectsForSelection(
        {name:label.Label, field:'label'},
        {name:label.Created, field:'created'},
        {name:label.Updated, field:'updated'}
    )
    let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})


    return (
        <Page
            title={label.MainModel}
            breadcrumbs={[{ name: label.MainModel, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmation}
              okCallback={this.saveUpload}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={this.state.modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message={label.DeleteConfirmationMessage}
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.MainModelDetail}/>
                <CardBody >
                  <Row>
                    <Col md={4}>
                      <Card>
                        <CardHeader>{label.Form}</CardHeader>
                        <CardBody>
                          <Row>
                            <CardBlock>
                              <FormGroup>
                                <Label for="name">{label.Name}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={!isEmpty(this.state.mainModel.label)?this.state.mainModel.label:""}
                                    onChange={(e) =>{
                                      mainModel.label = e.target.value
                                      this.setState({
                                        mainModel:mainModel
                                      })
                                    }}
                                    placeholder={label.EnterMainModelLabel}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label for="name">{label.Sortir}</Label>
                                <NumberInput
                                    name="sortir"
                                    className="form-control"
                                    value={(this.state.mainModel)?this.state.mainModel.sortir:""}
                                    onChangeEvent={(e, maskedvalue, floatvalue) => {
                                      e.preventDefault()
                                      mainModel.sortir = floatvalue
                                      this.setState({
                                        mainModel: mainModel,
                                      })
                                    }}
                                    placeholder="0"
                                    maxLength={15}>
                                </NumberInput>
                              </FormGroup>
                              <FormGroup>
                                <ItemOption
                                    title={label.SelectModel}
                                    objects={models}
                                    default={model!=null?model.id:null}
                                    noTranslation={true}
                                    callback={(model)=>{
                                      if(model!=null){
                                        mainModel.model = model
                                        this.setState({
                                          model:model,
                                          mainModel:mainModel
                                        })
                                      }else{
                                        mainModel.model = {}
                                        this.setState({
                                          model:{},
                                          mainModel:mainModel
                                        })
                                      }
                                    }}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ActiveOption
                                    default={mainModel.active}
                                    callback={(active)=>{
                                      mainModel.active = active
                                      this.setState({
                                        mainModel:mainModel
                                      })
                                    }}
                                />
                              </FormGroup>
                            </CardBlock>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonGroup className="float-left">
                                <Button color="danger" onClick={e => (
                                    this.setState({
                                      mainModel:null
                                    })
                                )}>{label.Cancel}</Button>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <ButtonGroup className="float-right">
                                <Button color="primary" onClick={e=>(
                                    this.confirmSave()
                                )}> {
                                  (mainModel && mainModel.id)?label.Update:label.Add
                                } </Button>
                              </ButtonGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={8}>
                      <Card body>
                        <Row>
                          <Col md={6}>
                            <ButtonGroup className="d-flex w-100">
                              <DropdownInput
                                  title={label.SortBy}
                                  options={orderOptions}
                                  onSelect={(item) => {
                                    this.refresh(ascending, item.field, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(ascending, "created", true)
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  options={ascendingOptions}
                                  onSelect={(item) => {
                                    this.refresh(item.field, sortir, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(true, sortir, true)
                                  }}/>
                            </ButtonGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Label}</th>
                                <th>{label.Sortir}</th>
                                <th>{label.Model}</th>
                                <th>{label.Status}</th>
                                <th>{label.Updated}</th>
                                <th>{label.Edit}</th>
                                <th>{label.Delete}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.mainModels.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">{++index}</th>
                                      <td>{item.label}</td>
                                      <td>{item.sortir}</td>
                                      <td>{item.model.systemType}</td>
                                      <td><ActiveLabel trueLabel={label.Active} falseLabel={label.Inactive} active={item.active}/></td>
                                      <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="primary" onClick={e=> {
                                          let mainModel = cloneObject(item)
                                          let model = mainModel.model
                                          this.setState({
                                            mainModel: mainModel,
                                            model:model
                                          })
                                        }}>
                                          <MdEdit/>
                                        </Button>
                                      </td>
                                      <td>
                                        <Button color="danger" onClick={e=> {
                                          let mainModel = cloneObject(item)
                                          this.setState({
                                            mainModel: mainModel
                                          }, () => {
                                            this.confirmDelete()
                                          })
                                        }}>
                                          <MdDelete/>
                                        </Button>
                                      </td>

                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>


        </Page>
    );
  }
}

export default Object.assign(MainModelPage, {ENDPOINT : "/mainModels"})
